import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Badge from "../badge/badge";
import Button from "../button/button";
import Popover from "../popover/popover";
import styles from "./userTable.module.css";
import EditIcon from "../../assets/icons/edit.svg";
import { useRole } from "../../context/UsersContext";
import { PHONE_REGEX_FORMATTER } from "../../utils/pagesMapper";
import { useInstitution } from "../../context/InstitutionContext";
import { readByInstitution, deleteUser } from "../../services/academetrics";
import UserDeleteIcon from "../../assets/icons/user-delete.svg";
import CircleXMarkIcon from "../../assets/icons/circle-xmark.svg";

const TableComponent = () => {
  const navigate = useNavigate();
  const { users, setUsers } = useRole();
  const { institution } = useInstitution();

  const [deletePopover, setDeletePopover] = useState("");

  useEffect(() => {
    if (institution?.id) fetchUsers();
  }, [institution?.id]);

  const fetchUsers = async () => {
    if (!institution?.id) return;
    const response = await readByInstitution(institution.id);

    setUsers(response?.users || []);
  };

  const handleEdit = (id) => {
    navigate(`/app/usuarios/edit/${id}`);
  };

  const formatPhoneNumber = (phoneNumber) => {
    return phoneNumber?.replace(PHONE_REGEX_FORMATTER, "($1) $2-$3");
  };

  const translateRole = (role) => {
    const roleMap = {
      'Admin': 'Administrador',
      'Manager': 'Gerente',
      'User': 'Usuário',
      'Viewer': 'Visualizador'
    };
    return roleMap[role] || role || '-';
  };

  const handleDeleteUser = async (id) => {
    await deleteUser(id);
    fetchUsers();
  };

  return (
    <div className={styles.tableContainer}>
      {users.length > 0 ? (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Usuário</th>
              <th>Instituição</th>
              <th>E-mail</th>
              <th>Perfil</th>
              <th>Telefone</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {users.map((item, index) => (
              <tr key={index}>
                <td>{item.firstName}</td>
                <td>{item.institutionName}</td>
                <td className={styles.primary}>{item.email}</td>
                <td>{translateRole(item?.role)}</td>
                <td>{formatPhoneNumber(item.phoneNumber)}</td>
                <td>
                  <Badge
                    text={item?.status === "Active" ? "Ativo" : "Inativo"}
                    color={item?.status === "Active" ? "green" : "red"}
                  />
                </td>
                <td className={styles.actions}>
                  <img
                    src={EditIcon}
                    alt="Editar"
                    onClick={() => handleEdit(item.id)}
                  />

                  <div className={styles.deletePopoverContainer}>
                    <img
                      src={CircleXMarkIcon}
                      alt="Excluir"
                      onClick={() => setDeletePopover(item.id)}
                    />

                    {deletePopover === item.id && (
                      <Popover
                        onClose={() => setDeletePopover("")}
                        content={
                          <div className={styles.deletePopover}>
                            <h6>Você realmente deseja excluir este usuário?</h6>

                            <Button
                              text="Excluir usuário"
                              variation="secondary"
                              size="big"
                              icon={UserDeleteIcon}
                              onClick={() => handleDeleteUser(item.id)}
                            />
                          </div>
                        }
                      />
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <h4>Nenhum usuário cadastrado</h4>
      )}
    </div>
  );
};

export default TableComponent;
